import { render, staticRenderFns } from "./demo.vue?vue&type=template&id=2aed11cf&scoped=true&"
var script = {}
import style0 from "./demo.vue?vue&type=style&index=0&id=2aed11cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aed11cf",
  null
  
)

export default component.exports